(() => {
  const getThemeIcon = (direction) => {
    const markup = window.arrows && window.arrows[`icon_${direction}`];
    if (!markup) return null;

    const template = document.createElement('template');
    template.innerHTML = markup.trim();
    return template.content.querySelector('svg');
  };

  const icons = {
    prev: getThemeIcon('prev'),
    next: getThemeIcon('next')
  };

  const normalizeArrow = (button, direction) => {
    if (!button || button.dataset.dmStandardArrow === direction || !icons[direction]) return;

    const preservedContent = Array.from(button.querySelectorAll('.products-counter-number'));
    // Keep the original counter nodes (and their listeners) on older browsers.
    while (button.firstChild) button.removeChild(button.firstChild);
    button.appendChild(icons[direction].cloneNode(true));
    preservedContent.forEach((counter) => button.appendChild(counter));
    button.dataset.dmStandardArrow = direction;
  };

  const normalizeWithin = (root) => {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.slick-arrow.slick-prev, [data-dm-theme-arrow="prev"]').forEach((button) => {
      normalizeArrow(button, 'prev');
    });

    scope.querySelectorAll('.slick-arrow.slick-next, [data-dm-theme-arrow="next"]').forEach((button) => {
      normalizeArrow(button, 'next');
    });
  };

  const start = () => {
    normalizeWithin(document);

    if (window.jQuery && window.jQuery.fn) {
      window.jQuery(document)
        .off('.dmStandardSliderArrows')
        .on('init.dmStandardSliderArrows reInit.dmStandardSliderArrows breakpoint.dmStandardSliderArrows', '.slick-slider', function () {
          normalizeWithin(this);
          normalizeWithin(this.parentElement);
        });
    }

    document.addEventListener('shopify:section:load', (event) => normalizeWithin(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
